import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchContactData = createAsyncThunk('join/fetchContactData', async () => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/contact`);
  return response.data;
});

const ContactSlice = createSlice({
  name: 'contact',
  initialState: {
    data: [],
    status: 'idle', 
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchContactData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchContactData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default ContactSlice.reducer;
